/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';

import {
  ActionSwapsComponent,
  DateComponent,
  PriceComponent,
  SwapTypeComponent,
  TextComponent,
  UserComponent,
} from '@components/table-components';
import { MutToTez } from '@utils/format';
import { Table } from '@versumstudios/ui';

const settings = [
  {
    key: 'sellerScreenName',
    label: 'From',
    Component: ({ sellerScreenName, seller, sellerIsYou, sellerIsCreator }: Record<string, any>) => (
      <UserComponent
        {...seller.user[0].user}
        parsedScreenName={sellerScreenName}
        address={seller.address}
        isYou={sellerIsYou}
        isCreator={sellerIsCreator}
      />
    ),
  },
  {
    key: 'type',
    label: 'Type',
    Component: ({ start_price, end_price, ending_time }: Record<string, any>) => (
      <SwapTypeComponent start_price={start_price} end_price={end_price} ending_time={ending_time} />
    ),
  },
  {
    key: 'amount_left',
    label: 'Quantity',
    Component: ({ amount_left }: Record<string, any>) => <TextComponent value={amount_left} />,
  },
  {
    key: 'timestamp',
    label: 'Date',
    Component: ({ timestamp }: Record<string, any>) => {
      return <DateComponent timestamp={timestamp} />;
    },
  },
  {
    key: 'ending_time',
    label: 'Ending',
    Component: ({ ending_time }: Record<string, any>) => {
      return ending_time ? <DateComponent timestamp={ending_time} /> : null;
    },
  },
  {
    key: 'current_price',
    label: 'Price',
    Component: ({ current_price }: Record<string, any>) => <PriceComponent value={MutToTez(current_price)} />,
  },
  {
    key: 'actions',
    label: 'Actions',
    Component: (props: any) => <ActionSwapsComponent {...props} />,
  },
];

interface ITableTokenSwaps {
  data: any[];
}

export const TableTokenSwaps: FC<ITableTokenSwaps> = ({ data }) => {
  return <Table settings={settings} data={data} />;
};
